module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/locateme.c9fc51fa..svg" + "?" + Date.now();